import { Component, Input } from '@angular/core';
import { TrackToolStep } from '@analytics/models';
import type { InnogyComponentRendering } from '@core/jss-models';
import { getFieldValue } from '@core/jss-utils';
import {
  initialsConverter,
  AutocompleteDirective,
  IsInvalidPipe,
} from '@innogy/utils-deprecated';
import { FormGroupControls, FormGroupState } from 'ngrx-forms';

import type { NameFormFields, NameFormValues } from './model/name-form.model';
import { TextComponent } from '../text/text.component';
import { InputErrorComponent } from '../input-error/input-error.component';

@Component({
  selector: 'wl-name-form',
  templateUrl: './name-form.component.html',
  standalone: true,
  imports: [
    TextComponent,
    AutocompleteDirective,
    IsInvalidPipe,
    InputErrorComponent,
  ],
})
export class NameFormComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering & { fields: NameFormFields };
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() controls?: FormGroupControls<NameFormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState!: FormGroupState<NameFormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabels = false;

  get initialsLabel() {
    return getFieldValue(this.rendering, 'InitialsLabel', '');
  }

  get initialsPlaceholder() {
    return getFieldValue(this.rendering, 'InitialsPlaceholder', '');
  }

  get initialsNotValidError() {
    return this.rendering?.fields.InitialsNotValidError;
  }

  get initialsRequiredError() {
    return this.rendering?.fields.InitialsRequiredError;
  }

  get insertionLabel() {
    return getFieldValue(this.rendering, 'InsertionLabel', '');
  }

  get insertionPlaceholder() {
    return getFieldValue(this.rendering, 'InsertionPlaceholder', '');
  }

  get lastNameLabel() {
    return getFieldValue(this.rendering, 'LastNameLabel', '');
  }

  get lastNamePlaceholder() {
    return getFieldValue(this.rendering, 'LastNamePlaceholder', '');
  }

  get lastNameRequiredError() {
    return this.rendering?.fields.LastNameRequiredError;
  }

  get lastNameInvalidError() {
    return this.rendering?.fields.LastNameNotValidError;
  }

  public readonly _initialsConverter = initialsConverter();

  get automationId(): string {
    return this.formState.id;
  }
}
